import PlanificacionDesarrollo from  './PlanificacionDesarrollo';

export default PlanificacionDesarrollo;